<script setup lang="ts">
import { range } from 'lodash-es'
import { computed } from 'vue'

const { numberOfPages } = defineProps<{
  numberOfPages: number
}>()

const currentPage = defineModel<number>({ required: true })

const PAGES_SHOWING_BEFORE_AND_AFTER = 2 // 前後に表示するページ数
const SHOWING_PAGES = PAGES_SHOWING_BEFORE_AND_AFTER * 2 + 1

// めんどくさいのでここからコメントは前後2ページずつ全部で5ページの前提で書きます
const showingPages = computed((): number[] => {
  // ページ数がそもそも5個以下の場合
  if (numberOfPages <= SHOWING_PAGES) {
    // 最初のページから最後のページまでを表示
    const startPage = 1
    const endPage = numberOfPages
    return range(startPage, endPage + 1)
  }

  // 現在のページの前に表示するページ数が2ページより少ない場合
  if (currentPage.value - PAGES_SHOWING_BEFORE_AND_AFTER < 1) {
    // 最初のページから5ページ目までを表示
    const startPage = 1
    const endPage = SHOWING_PAGES
    return range(startPage, endPage + 1)
  }

  // 現在のページの後に表示するページ数が2ページより少ない場合
  if (currentPage.value + PAGES_SHOWING_BEFORE_AND_AFTER > numberOfPages) {
    // 最後のページをendPageとして、そこから5ページ前をstartPageとする
    const endPage = numberOfPages
    const startPage = numberOfPages - SHOWING_PAGES + 1
    return range(startPage, endPage + 1)
  }

  // それ以外の場合は、現在のページを中心に前後2ページずつ表示
  // つまり、現在のページを中心に5ページを表示する
  const startPage = currentPage.value - PAGES_SHOWING_BEFORE_AND_AFTER
  const endPage = currentPage.value + PAGES_SHOWING_BEFORE_AND_AFTER

  return range(startPage, endPage + 1)
})
</script>

<template>
  <ul :class="$style.paginator">
    <li v-for="page in showingPages" :key="page">
      <button
        @click="currentPage = page"
        :disabled="page === currentPage"
        :class="{
          [$style.paginator__button]: true,
          [$style['paginator__button--current']]: currentPage === page,
        }"
      >
        {{ page }}
      </button>
    </li>
  </ul>
</template>

<style lang="scss" module>
.paginator {
  display: flex;
  gap: 16px;

  &__button {
    width: 32px;
    height: 32px;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    border-radius: 100%;
    color: $color-text-and-object-accent-primary;
    text-align: center;
    box-shadow: $shadow-4;

    &--current {
      background-color: $color-surface-accent-primary;
      color: $color-text-and-object-high-emphasis-inverse;
    }
  }
}
</style>
